module.exports = __webpack_public_path__ + "img/img_32389_0_440.7682151e.png";